export const TODOLISTS_FETCH = 'TODOLISTS/FETCH';
export const TODOLISTS_MERGE = 'TODOLISTS/MERGE';

export const TODOLIST_SELECT = 'TODOLIST/SELECT';
export const TODOLIST_CHANGE = 'TODOLIST/CHANGE';
export const TODOLIST_CREATE = 'TODOLIST/CREATE';
export const TODOLIST_SAVE = 'TODOLIST/SAVE';
